import { useElementHeight } from './useElementHeight';

export const useHeaderHeight = () => {
  const headerElement = document.getElementById('pih-root');
  return useElementHeight(headerElement);
};
